// src/utils/translations.ts
export const translations = {
  ar: {
    heroTitle: "نحو إصلاح عقاري متكامل",
    heroDescription:
      "وزارة العقارات وأملاك الدولة والإصلاح العقاري تقدم لكم أحدث الخدمات الإلكترونية لتسهيل المعاملات العقارية",
    learnMoreButton: "تعرف على مهام الوزارة",
    servicesButton: "الخدمات الإلكترونية",
    aboutMinistry: "عن الوزارة",
    loadingMinister: "جاري تحميل بيانات الوزير...",
    minister: "وزير العقارات",
    ministerWord: "كلمة الوزير",
    ministerCV: "السيرة الذاتية للوزير",
    readFullCV: "قراءة السيرة الذاتية كاملة",
    readMore: "قراءة المزيد",
    noMinisterData: "لا توجد بيانات للوزير",
    vision: "الرؤية",
    visionText:
      "أن نكون الوزارة الرائدة في إدارة وتنظيم القطاع العقاري، وأن نحقق نظاماً عقارياً متكاملاً يسهم في التنمية الاقتصادية والاجتماعية المستدامة.",
    mission: "الرسالة",
    missionText:
      "تنظيم وإدارة الأملاك العقارية الوطنية بكفاءة وشفافية، وتقديم خدمات عقارية متميزة للمواطنين والمستثمرين، ووضع السياسات والتشريعات التي تضمن حقوق الملكية وتشجع الاستثمار العقاري.",
    officialAnnouncements: "الإعلانات",
    loadingAnnouncements: "جاري تحميل الإعلانات...",
    fullDetails: "التفاصيل الكاملة",
    moreAnnouncements: "المزيد من الإعلانات",
    ministryNews: "أخبار الوزارة",
    loadingNews: "جاري تحميل الأخبار...",
    noNews: "لا توجد أخبار حالياً",
    moreNews: "المزيد من الأخبار",
    news: "الأخبار",
    backToMinistry: "العودة إلى صفحة الوزارة",
    backToAnnouncements: "العودة إلى صفحة الإعلانات",
    announcementNotFound: "الإعلان غير موجود",
    recentNews: "آخر الأخبار",
    recentAnnouncements: "الإعلانات الحديثة",
    recentLegislation: "التشريعات الحديثة",
    quickLinks: "روابط سريعة",
    viewAll: "عرض الكل",
    new: "جديد",
    noAnnouncements: "لا توجد إعلانات متاحة",
    noLegislation: "لا توجد تشريعات متاحة",

    // Add the new translations here inside ar object
    viewGallery: "عرض المعرض",
    watchVideo: "مشاهدة الفيديو",
    viewAllPhotos: "عرض جميع الصور",
    viewAllVideos: "عرض جميع الفيديوهات",
    mediaGallery: "الصور والفيديوهات",
    images: "الصور",
    videos: "الفيديوهات",
    noImages: "لا توجد صور متاحة",
    noVideos: "لا توجد فيديوهات متاحة",
    viewMore: "عرض المزيد",
    viewAllMedia: "عرض جميع الوسائط",
    sousEtablissements: "المؤسسات تحت الوصاية",
    noSousEtablissements: "لا توجد مؤسسات تحت الوصاية",
    visitWebsite: "زيارة الموقع",
    viewAllEtablissements: "عرض جميع المؤسسات",
    loading: "جاري التحميل...",
    ministryProjects: "مشاريع الوزارة",
    discoverDevelopmentProjects: "اكتشف أهم المشاريع والبرامج التنموية",
    searchProjects: "ابحث في المشاريع...",
    allProjects: "جميع المشاريع",
    clearSearch: "إلغاء البحث",
    details: "التفاصيل",
    externalLink: "رابط خارجي",
    noTitle: "بدون عنوان",
    noDescription: "لا يوجد وصف متوفر",
    error: "خطأ",
    errorLoadingProjects: "حدث خطأ أثناء تحميل المشاريع",
    retry: "إعادة المحاولة",
    loadingProjects: "جاري تحميل المشاريع...",
    noResults: "لا توجد نتائج",
    noProjects: "لا توجد مشاريع",
    noMatchingProjects: "لم يتم العثور على مشاريع تطابق بحثك",
    noProjectsAvailable: "لا توجد مشاريع متاحة حالياً",
    viewAllProjects: "عرض جميع المشاريع",
    close: "إغلاق",
    projects: "المشاريع",
    proceduresServices: "الإجراءات والخدمات",
    adminProceduresTitle: "إدارة الإجراءات والخدمات",
    addNewProcedure: "إضافة إجراء/خدمة جديدة",
    searchProceduresPlaceholder: "ابحث عن إجراء أو خدمة...",
    loadingData: "جاري تحميل البيانات...",
    noDataAvailable: "لا توجد بيانات متاحة",
    confirmDeleteProcedure: "هل أنت متأكد من حذف هذا الإجراء/الخدمة؟",
    deleteSuccess: "تم الحذف بنجاح",
    deleteError: "حدث خطأ أثناء الحذف",
    fetchError: "حدث خطأ أثناء جلب البيانات",
    saveSuccess: "تمت الإضافة بنجاح",
    updateSuccess: "تم التحديث بنجاح",
    saveError: "حدث خطأ أثناء حفظ البيانات",
    procedureTitleArabic: "العنوان (عربي)",
    procedureTitleFrench: "العنوان (فرنسي)",
    procedureFiles: "الملفات",
    procedureActions: "الإجراءات",
    editProcedureTitle: "تعديل الإجراء/الخدمة",
    addProcedureTitle: "إضافة إجراء/خدمة جديدة",
    procedureFormArabicDescription: "الوصف (عربي)",
    procedureFormFrenchDescription: "الوصف (فرنسي)",
    back: "رجوع",
    save: "حفظ",
    saving: "جاري الحفظ...",
    preview: "معاينة",
    download: "تحميل",
    active: "نشط",
    inactive: "غير نشط",

    adminNewsTitle: "إدارة المقالات",
    adminNewsCategoriesTitle: "إدارة تصنيفات الأخبار",
    addNews: "إضافة مقالة جديدة",
    searchNewsPlaceholder: "ابحث عن مقالة...",
    adminAnnouncementsTitle: "إدارة الإعلانات",
    addAnnouncement: "إضافة إعلان جديد",
    adminLegislationsTitle: "إدارة التشريعات",
    addLegislation: "إضافة تشريع جديد",
    uploadArabicFile: "تحميل الملف العربي",
    uploadFrenchFile: "تحميل الملف الفرنسي",
    adminMinistersTitle: "إدارة الوزارة",
    addMinister: "إضافة وزير جديد",
    adminUsersTitle: "إدارة المستخدمين",
    addUser: "إضافة مستخدم جديد",
    adminMessagesTitle: "إدارة الرسائل",
    adminProjectsTitle: "إدارة المشاريع",
    addProject: "إضافة مشروع جديد",
    adminSliderTitle: "إدارة السلايدر",
    addSlider: "إضافة سلايدر",
    adminInformationTitle: "إدارة المعلومات العامة",
    adminStructureTitle: "إدارة الهيكل الإداري",
    addStructure: "إضافة هيكل إداري جديد",
    adminLibraryTitle: "إدارة المكتبة المتعددة الوسائط",
    addLibraryItem: "إضافة عنصر جديد",
    adminLibraryCategoriesTitle: "إدارة تصنيفات المكتبة",
    addLibraryCategory: "إضافة تصنيف جديد",
    adminCategoriesTitle: "إدارة التصنيفات",

    adminCabinetTitle: "إدارة مكتب الوزير",
    addCabinetEntry: "إضافة سجل مكتب الوزير",
    adminMinisterWordTitle: "إدارة كلمة الوزير",
    addMinisterWord: "إضافة كلمة الوزير",
    adminMotMinistreTitle: "إدارة كلمة الوزير",
    addMotMinistre: "إضافة كلمة الوزير",
    confirmDelete: "هل أنت متأكد من الحذف؟",
    searchPlaceholder: "ابحث...",
    noRecordsFound: "لا توجد بيانات متاحة",
    // CONTACT PAGE
    contactUs: "تواصل معنا",
    contactSubtitle: "يسعدنا تلقي استفساراتكم وملاحظاتكم",
    contactInfo: "معلومات الاتصال",
    sendMessage: "إرسال رسالة",
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    subject: "الموضوع",
    message: "الرسالة",
    send: "إرسال",
    sending: "جاري الإرسال...",
    address: "العنوان",
    phone: "الهاتف",
    workingHours: "ساعات العمل",
    ourLocation: "موقعنا على الخريطة",
    openInMaps: "فتح في خرائط جوجل",
    openFullMap: "فتح الخريطة كاملة",
    messageSentSuccess: "تم إرسال رسالتك بنجاح. سنرد عليك قريباً.",
    messageSentError: "حدث خطأ أثناء إرسال الرسالة. يرجى المحاولة مرة أخرى.",
    requiredField: "هذا الحقل مطلوب",
    invalidEmail: "بريد إلكتروني غير صالح",
  },
  fr: {
    heroTitle: "Vers une réforme foncière intégrée",
    heroDescription:
      "Le Ministère des Domaines et de la Réforme Foncière vous propose les derniers services électroniques pour faciliter les transactions immobilières",
    learnMoreButton: "Découvrez les missions du ministère",
    servicesButton: "Services électroniques",
    aboutMinistry: "À propos du ministère",
    loadingMinister: "Chargement des données du ministre...",
    minister: "Ministre des Domaines",
    ministerWord: "Mot du ministre",
    ministerCV: "Curriculum vitae du ministre",
    readFullCV: "Lire le CV complet",
    readMore: "Lire la suite",
    noMinisterData: "Aucune donnée disponible pour le ministre",
    vision: "Vision",
    visionText:
      "Être le ministère leader dans la gestion et la régulation du secteur foncier, et réaliser un système foncier intégré qui contribue au développement économique et social durable.",
    mission: "Mission",
    missionText:
      "Organiser et gérer efficacement et transparentement les propriétés foncières nationales, offrir des services immobiliers exceptionnels aux citoyens et aux investisseurs, et établir des politiques et législations qui garantissent les droits de propriété et encouragent l'investissement immobilier.",
    officialAnnouncements: "Annonces officielles",
    loadingAnnouncements: "Chargement des annonces...",
    fullDetails: "Détails complets",
    moreAnnouncements: "Plus d'annonces",
    ministryNews: "Actualités du ministère",
    loadingNews: "Chargement des actualités...",
    noNews: "Aucune actualité pour le moment",
    moreNews: "Lire plus",
    news: "Actualités",
    backToMinistry: "Retour à la page du ministère",
    backToAnnouncements: "Retour à la page des annonces",
    announcementNotFound: "Annonce non trouvée",
    recentNews: "Actualités récentes",
    recentAnnouncements: "Annonces récentes",
    recentLegislation: "Législation récente",
    quickLinks: "Liens rapides",
    viewAll: "Voir tout",
    new: "Nouveau",
    noAnnouncements: "Aucune annonce disponible",
    noLegislation: "Aucune législation disponible",
    projects: "Projets",
    // Add the new translations here inside fr object
    viewGallery: "Voir la galerie",
    watchVideo: "Regarder la vidéo",
    viewAllPhotos: "Voir toutes les photos",
    viewAllVideos: "Voir toutes les vidéos",
    mediaGallery: "Photos et Vidéos",
    images: "Photos",
    videos: "Vidéos",
    noImages: "Aucune image disponible",
    noVideos: "Aucune vidéo disponible",
    viewMore: "Voir plus",
    viewAllMedia: "Voir tous les médias",
    sousEtablissements: "Établissements sous tutelle",
    noSousEtablissements: "Aucun établissement sous tutelle",
    visitWebsite: "Visiter le site",
    viewAllEtablissements: "Voir tous les établissements",
    loading: "Chargement...",
    ministryProjects: "Projets du Ministère",
    discoverDevelopmentProjects:
      "Découvrez les projets et programmes de développement les plus importants",

    searchProjects: "Rechercher dans les projets...",
    allProjects: "Tous les projets",
    clearSearch: "Annuler la recherche",
    details: "Détails",
    externalLink: "Lien externe",
    noTitle: "Sans titre",
    noDescription: "Aucune description disponible",
    error: "Erreur",
    errorLoadingProjects:
      "Une erreur s'est produite lors du chargement des projets",
    retry: "Réessayer",
    loadingProjects: "Chargement des projets...",
    noResults: "Aucun résultat",
    noProjects: "Aucun projet",
    noMatchingProjects: "Aucun projet correspondant à votre recherche",
    noProjectsAvailable: "Aucun projet disponible pour le moment",
    viewAllProjects: "Voir tous les projets",
    close: "Fermer",
    proceduresServices: "Procédures et Services",
    adminProceduresTitle: "Gestion des Procédures et Services",
    addNewProcedure: "Ajouter une procédure/service",
    searchProceduresPlaceholder: "Rechercher une procédure ou un service...",
    loadingData: "Chargement des données...",
    noDataAvailable: "Aucune donnée disponible",
    confirmDeleteProcedure:
      "Êtes-vous sûr de vouloir supprimer cette procédure/service ?",
    deleteSuccess: "Suppression réussie",
    deleteError: "Erreur lors de la suppression",
    fetchError: "Erreur lors de la récupération des données",
    saveSuccess: "Ajout réussi",
    updateSuccess: "Mise à jour réussie",
    saveError: "Erreur lors de l'enregistrement des données",
    adminNewsTitle: "Gestion des Actualités",
    adminNewsCategoriesTitle: "Gestion des catégories des actualités",
    addNews: "Ajouter un article",
    searchNewsPlaceholder: "Rechercher un article...",
    adminAnnouncementsTitle: "Gestion des Annonces",
    addAnnouncement: "Ajouter une annonce",
    adminLegislationsTitle: "Gestion des Législations",
    addLegislation: "Ajouter une législation",
    uploadArabicFile: "Télécharger le fichier arabe",
    uploadFrenchFile: "Télécharger le fichier français",
    adminMinistersTitle: "Gestion des Ministres",
    addMinister: "Ajouter un ministre",
    adminUsersTitle: "Gestion des Utilisateurs",
    addUser: "Ajouter un utilisateur",
    adminMessagesTitle: "Gestion des Messages",
    adminProjectsTitle: "Gestion des Projets",
    addProject: "Ajouter un projet",
    adminSliderTitle: "Gestion du Slider",
    addSlider: "Ajouter un slider",
    adminInformationTitle: "Gestion des Informations Générales",
    adminStructureTitle: "Gestion des Structures Administratives",
    addStructure: "Ajouter une structure administrative",
    adminLibraryTitle: "Gestion de la Médiathèque",
    addLibraryItem: "Ajouter un élément",
    adminLibraryCategoriesTitle: "Gestion des Catégories de la Bibliothèque",
    addLibraryCategory: "Ajouter une catégorie",
    adminCategoriesTitle: "Gestion des Catégories",
    addCategory: "Ajouter une catégorie",
    adminCabinetTitle: "Gestion du Cabinet du Ministre",
    addCabinetEntry: "Ajouter un enregistrement du cabinet du ministre",
    adminMinisterWordTitle: "Gestion du Mot du Ministre",
    addMinisterWord: "Ajouter un mot du ministre",
    adminMotMinistreTitle: "Gestion du mot du ministre",
    addMotMinistre: "Ajouter le mot du ministre",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
    back: "Retour",
    save: "Enregistrer",
    saving: "Enregistrement en cours...",
    preview: "Aperçu",
    download: "Télécharger",
    active: "Actif",
    inactive: "Inactif",

    // CONTACT PAGE
    contactUs: "Contactez-nous",
    contactSubtitle:
      "Nous sommes à votre écoute pour toute demande ou remarque",
    contactInfo: "Informations de contact",
    sendMessage: "Envoyer un message",
    fullName: "Nom complet",
    email: "Adresse e-mail",
    subject: "Objet",
    message: "Message",
    send: "Envoyer",
    sending: "Envoi en cours...",
    address: "Adresse",
    phone: "Téléphone",
    workingHours: "Heures de travail",
    ourLocation: "Notre localisation sur la carte",
    openInMaps: "Ouvrir dans Google Maps",
    openFullMap: "Ouvrir la carte complète",
    messageSentSuccess:
      "Votre message a été envoyé avec succès. Nous vous répondrons bientôt.",
    messageSentError:
      "Une erreur est survenue lors de l’envoi du message. Veuillez réessayer.",
    requiredField: "Ce champ est obligatoire",
    invalidEmail: "Adresse e-mail invalide",
  },
};

export const getTranslation = (key: string, language: "ar" | "fr"): string => {
  return (
    translations[language][
      key as keyof (typeof translations)[typeof language]
    ] || key
  );
};
